import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Friendly in-app "you're offline" bar so the app never feels broken without a connection.
export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-banner"
      className="fixed top-0 inset-x-0 z-[100] bg-[#FF453A] text-white text-sm font-medium py-2 px-4 flex items-center justify-center gap-2 shadow-lg"
      role="status"
    >
      <WifiOff size={15} /> You're offline — some features may not work until you reconnect.
    </div>
  );
}
